"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CF_ICE_ORIG_IPS_DNS_BASE = exports.CLIENT_TURN_REFRESH_TIME_S = exports.TURN_REFRESH_INTERVAL_S = exports.TURN_CREDENTIAL_EXPIRY_S = void 0;
exports.TURN_CREDENTIAL_EXPIRY_S = 24 * 60 * 60;
exports.TURN_REFRESH_INTERVAL_S = 4 * 60 * 60;
const ONE_HOUR_S = 60 * 60;
exports.CLIENT_TURN_REFRESH_TIME_S = exports.TURN_CREDENTIAL_EXPIRY_S - exports.TURN_REFRESH_INTERVAL_S - ONE_HOUR_S;
exports.CF_ICE_ORIG_IPS_DNS_BASE = "cf.turn.gather.town";
//# sourceMappingURL=turn.js.map